import axios from 'axios';
import {
  PRICING_REQUEST,
  PRICING_SUCCESS,
  PRICING_FAIL,
} from '../constants/pricingConstants';
import { detectMarket } from '../utils/market';

export const fetchPricingConfig = () => async (dispatch) => {
  try {
    dispatch({ type: PRICING_REQUEST });

    const market = detectMarket();
    const { data } = await axios.get(`/api/pricing/?market=${encodeURIComponent(market)}`);

    dispatch({
      type: PRICING_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PRICING_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};
